<template>
  <div
    style="width: 800px;height: 1100px;padding: 30px 50px 0 50px;position: relative;"
    class="font-box"
    :style="{
      'background-image': `url(${bgImage})`,
      'background-size': `100% 100%`
    }"
  >
    <!-- 标题 -->
    <tk-image
      :src="titleImage"
      class="full-width"
      size="contain"
    ></tk-image>
    <!-- 二维码 -->
    <tk-flex middle center class="full-width" style="padding: 20px">
      <div
        class="full-width"
        style="
          background: white;
          border-radius: 40px;
          box-shadow: 4px 4px 6px 1px rgba(0, 0, 0, 0.3);
        "
      >
        <tk-flex
          column middle center
          style="padding:50px 50px 20px 50px;height:640px"
        >
          <!-- 二维码 -->
          <tk-flex
            middle center column
            class="full-width full-height"
            style="position: relative;"
          >
            <div
              style="position:absolute; width:100%;height:100%"
              :style="{
                'background-image': `url(${codeBgImage})`,
                'background-size': `100% 100%`,
                }"
            >
            </div>
            <img
              :src="qrCode"
              width="550px"
              height="550px"
            />
          </tk-flex>
          <div style="font-size:30px">打开微信扫一扫</div>
        </tk-flex>
        <!-- 门店名称 -->
        <div
          style="background:#373737;text-align:center;color:#ffffff;padding: 10px 5px;font-size:40px;border-radius:0 0 40px 40px;font-weight:700"
        >{{store.appletDisplayName}}</div>
      </div>
    </tk-flex>
    <!-- 底部 -->
    <div
      style="width: 500px;position: absolute;bottom: 15px;left:30px"
    >
      <tk-image
        :src="bottomImage"
        class="full-width"
        size="contain"
      ></tk-image>
    </div>
    <!-- 底部商品图 -->
    <div
      style="width: 200px;position: absolute;bottom: 0;left:560px"
    >
      <tk-image
        :src="productImage"
        class="full-width"
        size="contain"
      ></tk-image>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      storeId: '',
      store: null,
      titleImage: 'https://s3.moke.cloud/tianneng/266ac4db-9ec7-43f0-ae3c-a3d9c4162d5e.png',
      bottomImage: 'https://s3.moke.cloud/tianneng/6ed4c761-b1be-45f4-80fe-13884cab7164.png',
      productImage: 'https://s3.moke.cloud/tianneng/a8bc98d5-5199-4ac4-a174-0db346e1c846.png',
      codeBgImage: 'https://s3.moke.cloud/tianneng/fbdd3509-23aa-4ce9-8a28-db3ee2f36e7e.png',
      bgImage: 'https://s3.moke.cloud/tianneng/b4f7dcf3-01a6-4687-b1de-55a51c7345a4.jpg',
      qrCode: '',
      env: 'online'
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.storeId = this.getUrlKey(`storeId`)
      this.env = this.getUrlKey(`env`) || 'online'
      let baseUrl = 'https://cloud.tianneng.mokekeji.com'
      if (this.env === 'dev') {
        baseUrl = 'https://cloud.tianneng-dev.mokekeji.com'
      }
      let { data: url } = await this.$tkParse.post(`${baseUrl}/wx/getStoreCodePoster`, {
        params: this.storeId
      })
      this.qrCode = url.url
      let { data: res } = await this.$tkParse.get(`${baseUrl}/classes/store/${this.storeId}`)
      this.store = res
    },
    // 获取参数
    getUrlKey (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
    }
  }
}
</script>
<style>
.font-box {
  font-weight: bold;
  font-family: "Source Han Sans", "Source Han Sans CN", Arial, Helvetica, sans-serif;
}
</style>
